export default "__VITE_ASSET__f2a87b34__"